import * as Sentry from "@sentry/react";
import { configure as configureMobX } from "mobx";
import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import initialzeAmplify from "./services/AmplifyService";
import "./styles/index.scss";

// Initialize Sentry
Sentry.init({
    dsn: "https://4a50cfac6552bebd724e9718c3b2b34a@o4508931637706752.ingest.us.sentry.io/4508931823763456",
    integrations: [
        new Sentry.BrowserTracing({
            tracingOrigins: ["localhost", /^https:\/\/enrollment\.letsplaymusicsite\.com/]
        }),
        new Sentry.Replay({
            maskAllText: false,
            blockAllMedia: false,
            maskAllInputs: false,
            networkDetailAllowUrls: ['https://api.letsplaymusicsite.com/v2/registrations'],
            networkRequestHeaders: ['X-Custom-Header'],
            networkResponseHeaders: ['X-Custom-Header'],
        })
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    networkDetailAllowUrls: ['https://api.letsplaymusicsite.com/v2/registrations'],
    networkRequestHeaders: ['X-Custom-Header'],
    networkResponseHeaders: ['X-Custom-Header'],
});

configureMobX({ enforceActions: "never" });
initialzeAmplify();

ReactDOM.render(<App />, document.getElementById("root"));
